<div class="viewer-zoom d-flex flex-column">
  <div class="sr-only" role="status" aria-live="polite">{{ statusMessage }}</div>
  <span class="align-self-center viewer-zoom-label">Zoom</span>
  <div class="viewer-zoom-buttons" [ngbTooltip]="tooltipText">
    <zbp-button-component id="zoomOutButton"
            type="button"
            [ariaLabel]="'Zoom Out, current zoom is ' + zoomLevel + '%'"
            [disabled]="!enabled || zoomLevel <= zoomMin"
            (click)="handleZoomOut()"
            [theme]="zoomOutActive ? 'primary' : 'blackText'"
            [iconName]="zbpIconNames.magnifyingGlassWithMinusIcon">
    </zbp-button-component>
    <zbp-button-component id="zoomInButton"
            type="button"
            [ariaLabel]="'Zoom In, current zoom is ' + zoomLevel + '%'"
            [disabled]="!enabled || zoomLevel >= zoomMax"
            (click)="handleZoomIn()"
            [theme]="zoomInActive ? 'primary' : 'blackText'"
            [iconName]="zbpIconNames.magnifyingGlassWithPlusIcon">
    </zbp-button-component>
  </div>
</div>
